module.exports = __webpack_public_path__ + "static/media/icon_96.20fc173a.svg";